import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { supabase } from "../lib/supabaseClient";

export default function UpdatePassword() {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError(t("updatePassword.errors.mismatch"));
      return;
    }

    if (password.length < 6) {
      setError(t("updatePassword.errors.tooShort", { count: 6 }));
      return;
    }

    setLoading(true);

    try {
      const { error: updateError } = await supabase.auth.updateUser({ password });
      if (updateError) throw updateError;

      window.alert(t("updatePassword.success"));
      navigate("/login");
    } catch (updateError) {
      console.error("Password update error:", updateError);
      setError(updateError.message || t("updatePassword.errors.generic"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="display-title text-3xl mb-2">Artkiv</h1>
          <h2 className="font-serif text-2xl">{t("updatePassword.title")}</h2>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-sm p-8 space-y-6">
          <div>
            <label className="block text-sm mb-2">{t("updatePassword.newPassword")}</label>
            <input
              type="password"
              placeholder={t("updatePassword.newPasswordPlaceholder", { count: 6 })}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-control-artsy w-full"
              required
              minLength={6}
              disabled={loading}
            />
          </div>

          <div>
            <label className="block text-sm mb-2">{t("updatePassword.confirmPassword")}</label>
            <input
              type="password"
              placeholder={t("updatePassword.confirmPasswordPlaceholder")}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="form-control-artsy w-full"
              required
              minLength={6}
              disabled={loading}
            />
          </div>

          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-xl">
              <p className="text-red-700 text-sm">{error}</p>
            </div>
          )}

          <button
            type="submit"
            className="btn-artsy btn-primary-artsy w-full"
            disabled={loading}
          >
            {loading ? t("updatePassword.updating") : t("updatePassword.submit")}
          </button>
        </form>
      </div>
    </div>
  );
}
